import { combineReducers } from "@reduxjs/toolkit";
import languageReducer from "./reducer.slice";

const rootReducer = combineReducers({
    language: languageReducer,
});

export default rootReducer;
